module.exports = __webpack_public_path__ + "media/site_templates/www.excavate.company/images/splash-5609ed9767c0bfce2e4629d649eac599.jpg";